/* eslint-disable @angular-eslint/prefer-standalone */
import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import { PoModalAction, PoModalComponent } from '@po-ui/ng-components';
import { filter } from 'rxjs/internal/operators/filter';
import { LoginService } from 'src/app/shared/services/login.service';
import { User } from './core/home/login/shared/user';
import { BaseLoginComponent } from './shared/component/base/base-login-component';
import { Login } from './shared/interfaces/login.model';

@Component({
  selector: 'tgv-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrls: ['./core/loading-po-sync/loading-po-sync.component.css']
})
export class AppComponent extends BaseLoginComponent implements OnInit {
  @ViewChild(PoModalComponent, { static: true }) modalLogin: PoModalComponent;
  isHideLoading = false;
  loginForm: UntypedFormGroup;
  intervalStarted;
  modalActions: Array<PoModalAction>;

  constructor(
    private swUpdate: SwUpdate,
    private loginService: LoginService,
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    protected override injector: Injector
  ) {
    super(injector);

    if (this.swUpdate.isEnabled) {
      swUpdate.checkForUpdate();
      swUpdate.versionUpdates.pipe(filter(evt => evt.type === 'VERSION_READY')).subscribe(async () => {
        await swUpdate.activateUpdate();
        if (confirm(this.literals.str0534)) {
          location.reload();
        }
      });
    }
  }

  ngOnInit(): void {
    this.modalActions = this.getModalActions();
    this.initSync();
    this.listenUserToken();
    this.onInitForm();
    this.refreshUserToken();
  }

  getModalActions(): Array<PoModalAction> {
    return [
      {
        label: this.literals.str0524,
        action: this.doLogin.bind(this),
        loading: false,
        disabled: true
      },
      {
        label: this.literals.str0034,
        danger: true,
        action: this.closeModalAndRedirectToLogin.bind(this)
      }
    ];
  }

  async initSync(): Promise<void> {
    const user = localStorage.getItem('user');
    this.isHideLoading = false;
    if (user) {
      await this.userService.existUser(user);
    }
  }

  listenUserToken(): void {
    this.loginService.getExpiredToken().subscribe(res => {
      if (res) {
        this.modalLogin.open();
        this.isHideLoading = false;
      } else {
        this.modalLogin.close();
        this.isHideLoading = true;
      }
    });
  }

  doLogin(): void {
    const loginInfo = this.getLoginUserInfo();
    this.modalActions[0].loading = true;
    this.onUserAuth(loginInfo);
  }

  setLoggedUserToStorageAndLogin(user: User): void {
    localStorage.setItem('user', user.login);
    this.modalActions[0].loading = false;
    this.modalLogin.close();
    this.clearForm();
    this.router.navigate(['carga']).then(() => this.isHideLoading = true);
  }

  onInitForm(): void {
    this.loginForm = this.formBuilder.group({
      userLogin: ['', Validators.required],
      userPassword: ['', Validators.required],
      userAlias: ['', Validators.required]
    });
  }

  getLoginUserInfo(): Login {
    return {
      login: this.loginForm.value.userLogin,
      password: this.loginForm.value.userPassword,
      alias: this.loginForm.value.userAlias
    };
  }

  clearForm(): void {
    this.loginForm.reset();
  }

  enableConfirmButton(): void {
    if (this.loginForm.valid) {
      this.modalActions[0].disabled = false;
    } else {
      this.modalActions[0].disabled = true;
    }
  }

  closeModalAndRedirectToLogin(): void {
    this.modalLogin.close();
    this.router.navigate(['login']);
    this.isHideLoading = true;
  }

  refreshUserToken(): void {
    this.loginService.getAuth().subscribe(hasLogin => {
      if (hasLogin) {
        if (this.intervalStarted === undefined) {
          this.intervalStarted = setInterval(() => this.loginService.refreshUserToken(), 3630000);
        }
      } else {
        clearInterval(this.intervalStarted);
      }
    });
  }

  setCancelLoading(): void {
    this.modalActions[0].loading = false;
  }
}
